<template>
  <section class="section--comp">
    <div class="container items-center">
      <h3 class="section--h3 text-4xl">Curate</h3>
      <p class="section--p text-xl text-center">Well begun is half done. After we have identified the gaps and preferences of the talent, o curating a good learning li</p>
      <vs-row vs-type="flex" vs-justify="start">
        <vs-col class="items-left" vs-w="6" vs-sm="12">
          <h3 class="section--h3 text-4xl">Training Library</h3>
          <p class="section--p mb-1 text-xl">In an increasingly agile business world, building training effectively is about much more than pumping out courses as quickly as possible.</p>
          <p class="section--p text-xl">L&D needs to find a way to keep up with the demand for corporate learning without comprising on quality. Technology plays a huge role in creating efficiencies, and the time is right to embrace learning technology, collaboration with SMEs, and rapid course design.</p>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="center" vs-align="start" vs-w="6" vs-sm="12">
          <img src="../../../../../src/assets/images/demo/alex-training-library.png" align="center" width="100%"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-start">
        <vs-col class="df-col" vs-type="flex" vs-justify="center" vs-align="start" vs-w="6" vs-sm="12">
          <img src="../../../../../src/assets/images/demo/alex-distributed-trainings.png" align="center" width="100%"/>
        </vs-col>
        <vs-col class="df-col items-left" vs-w="6" vs-sm="12">
          <h3 class="section--h3 text-4xl">How to Curate your Micro-Learning Library for Distributed Trainings?</h3>
          <p class="section--p text-xl">It’s erroneous to think of simply breaking long content into 5-minute segments. Microlearning modules should stand on their own. Like all great learning courses; your content should be created and curated with instructional design, informational section, skill practice will require modules with diagnostic assessment.</p>
        </vs-col>
      </vs-row>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  section {
    padding: 10rem 10rem 7rem 10rem;
  }
  .vs-row {
    margin-bottom: 60px;
  }
  .vs-col {
    padding: 1.5rem;
  }
  @media (max-width: 1200px) {
    section {
      padding: 10rem 0;
    }
  }
</style>
